import styled from 'styled-components';

import * as colors from 'components/common/colorConstants';
import * as breakpoints from '../common/mediaQueries';

export const Container = styled.div`
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: -57px;
  width: 190px;
  left: 65px;
  margin-left: 2px;
  background-color: ${colors.purple1};
  border-radius: 3px;
  padding: 18px 20px;
  z-index: 1000;
  font-weight: bold;
  font-family: 'Roboto', sans-serif;
  animation-name: growAndFadeIn;
  animation-direction: forwards;
  animation-duration: 0.5s;

  @keyframes growAndFadeIn {
    0% {
      width: 170px;
      height: 100px;
      opacity: 0;
    }
    20% {
      opacity: 0;
    }
    100% {
      width: 190px;
      height: 122px;
    }
  }

  &:before {
    content: '';
    position: absolute;
    height: 0px;
    width: 0px;
    top: 25px;
    left: -14px;
    border-width: 7px;
    border-color: transparent ${colors.purple1} transparent transparent;
    border-style: solid;
  }

  h1 {
    font-size: 14px;
    line-height: 16px;
    font-weight: bold;
    margin: 0px 0px 10px 0px;
    padding: 0px;
    color: ${colors.whiteText};
    animation-name: fadeIn;
    animation-duration: 0.5s;
    animation-delay: 0s;
    animation-fill-mode: forwards;

    @keyframes fadeIn {
      0% {
        opacity: 0;
      }
      40% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
    }
  }

  p {
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
    margin: 0px;
    color: ${colors.lightGray14};
    animation-name: fadeIn;
    animation-duration: 0.5s;
    animation-delay: 0s;
    animation-fill-mode: forwards;

    @keyframes fadeIn {
      0% {
        opacity: 0;
      }
      40% {
        opacity: 0;
      }
      100% {
        opacity: 1;
      }
    }
  }

  span {
    font-size: 10px;
  }

  @media (min-height: ${breakpoints.mediumHeight}) {
    left: 65px;
    bottom: -54px;
  }
`;
